import { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import "../../../styles/website/ProOnlineToast.css";

/* =========================================================
   کارت «قابلیت پرو آنلاین اضافه شد» — داخل بخش چپِ hero
   تم نارنجی با رنگ اصلی #ee6c4d
   مراحل: ورود کارت → باز شدن و نمایش پیام → ترکیدن و پخش‌شدن
   تی‌شرت، عینک، کفش، کلاه و ... روی کل صفحه → جمع شدن و برگشت
   به جای خودش (یه نشان کوچیک)
   با هر بار کلیک روی کارت، همین مراحل دوباره تکرار می‌شه.

   استفاده: داخل <div className="hero-visual"> قرارش بده.
   ========================================================= */

const SEEN_KEY = "pro-online-toast-seen";
const ITEM_COUNT = 90; // تعداد آیتم‌هایی که می‌ریزند
const ITEM_TYPES = 8; // تعداد شکل‌ها (symbolهای پایین)

// رنگ آیتم‌ها: طیف‌های مختلف از رنگ تم (#ee6c4d)
const COLORS = [
  "#ee6c4d", // رنگ اصلی تم
  "#f58c72",
  "#fdb8a7",
  "#b14e37",
  "#ee6c4d",
  "#ffd5ca",
];

// زمان‌بندی مراحل (میلی‌ثانیه)
const INTRO_DELAY_MS = 600; // مکث بعد از لود صفحه تا ورود کارت
const BURST_DELAY_MS = 700; // از لحظه‌ی باز شدن کارت تا ترکیدن
const OPEN_MS = 5500; // مدت باز ماندن کارت قبل از جمع شدن
const LEAVES_MS = 9000; // مدت ماندن لایه‌ی آیتم‌ها (باید از بلندترین آیتم بیشتر باشد)

const rand = (min, max) => min + Math.random() * (max - min);

// آیتم‌ها از مرکز آیکن شروع می‌کنن و به نقطه‌های تصادفی روی «کل صفحه» پخش می‌شن
function makeItems(ox, oy) {
  const vw = window.innerWidth;
  const vh = window.innerHeight;

  return Array.from({ length: ITEM_COUNT }, (_, i) => {
    const targetX = rand(0.03, 0.97) * vw;
    const targetY = rand(0.05, 0.7) * vh;
    return {
      id: i,
      shape: i % ITEM_TYPES,
      color: COLORS[Math.floor(Math.random() * COLORS.length)],
      size: Math.round(rand(16, 28)),
      dx: targetX - ox,
      dy: targetY - oy,
      drift: rand(-120, 120),
      rot: (Math.random() < 0.5 ? -1 : 1) * Math.round(rand(240, 900)),
      delay: rand(0, 0.5),
      dur: rand(4.2, 7.2),
      swayDur: rand(1.1, 2.3),
      sway: Math.round(rand(8, 24)),
    };
  });
}

/* آیکن کیف خرید — برای کارت */
const BagIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M5 8.5H19L20 21H4L5 8.5Z"
      fill="currentColor"
      fillOpacity="0.28"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 8.5V7C8.5 5.1 10 3.5 12 3.5C14 3.5 15.5 5.1 15.5 7V8.5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

/* اسپرایت ۸ نوع آیتم: تی‌شرت، عینک، کفش ورزشی، کلاه، پیراهن، کیف، کفش پاشنه‌بلند، ساعت */
const ItemSprites = () => (
  <svg
    width="0"
    height="0"
    style={{ position: "absolute" }}
    aria-hidden="true"
    focusable="false"
  >
    <defs>
      {/* ۰ — تی‌شرت */}
      <symbol id="pt-item-0" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M8.2 3L3 5.8L1.8 10L5.6 11.4L6.4 9.6V20.5C6.4 21 6.8 21.4 7.3 21.4H16.7C17.2 21.4 17.6 21 17.6 20.5V9.6L18.4 11.4L22.2 10L21 5.8L15.8 3C15.4 4.8 13.9 5.9 12 5.9C10.1 5.9 8.6 4.8 8.2 3Z"
        />
        <path
          d="M8.2 3C8.6 4.8 10.1 5.9 12 5.9C13.9 5.9 15.4 4.8 15.8 3"
          stroke="rgba(0,0,0,.28)"
          strokeWidth="1.1"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M2.1 9L6 10.4M21.9 9L18 10.4"
          stroke="rgba(255,255,255,.45)"
          strokeWidth="1"
          strokeLinecap="round"
          fill="none"
        />
      </symbol>

      {/* ۱ — عینک آفتابی گرد */}
      <symbol id="pt-item-1" viewBox="0 0 24 24">
        <circle
          cx="7"
          cy="13.2"
          r="4.4"
          fill="currentColor"
          fillOpacity="0.55"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <circle
          cx="17"
          cy="13.2"
          r="4.4"
          fill="currentColor"
          fillOpacity="0.55"
          stroke="currentColor"
          strokeWidth="1.8"
        />
        <path
          d="M11.4 12.4Q12 10.8 12.6 12.4"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M2.7 12.2L1.8 8.6M21.3 12.2L22.2 8.6"
          stroke="currentColor"
          strokeWidth="1.7"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M4.6 12.2C5 11 5.9 10.4 7 10.3M14.6 12.2C15 11 15.9 10.4 17 10.3"
          stroke="rgba(255,255,255,.75)"
          strokeWidth="1.2"
          strokeLinecap="round"
          fill="none"
        />
      </symbol>

      {/* ۲ — کفش ورزشی */}
      <symbol id="pt-item-2" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M2.5 6.5H6.6C7 8.6 8.4 9.6 10.4 10.2L16.8 11.8C19.4 12.5 21.6 13.8 21.6 16.2V17.4H2.5Z"
        />
        <path
          fill="rgba(255,255,255,.8)"
          stroke="currentColor"
          strokeWidth="1.2"
          strokeLinejoin="round"
          d="M2 17.4H22.2V19C22.2 19.9 21.5 20.6 20.6 20.6H3.6C2.7 20.6 2 19.9 2 19Z"
        />
        <path
          d="M10.6 11.8L12.3 13M13 12.4L14.7 13.6M15.4 13L17 14.2"
          stroke="rgba(255,255,255,.8)"
          strokeWidth="1.2"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M18.2 17.4C18.2 15.2 17.6 14 16.2 13.2"
          stroke="rgba(0,0,0,.22)"
          strokeWidth="1"
          strokeLinecap="round"
          fill="none"
        />
      </symbol>

      {/* ۳ — کلاه کپ */}
      <symbol id="pt-item-3" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M6 15.2C6 9.6 9.2 6 13.2 6C17.2 6 20.2 9.6 20.2 15.2Z"
        />
        <path
          fill="currentColor"
          d="M2 16.2C2 15.2 4.4 14.7 8 14.7H20.2V16.4C20.2 17.2 19.5 17.8 18.6 17.8H7C4 17.8 2 17.2 2 16.2Z"
        />
        <path
          fill="rgba(0,0,0,.2)"
          d="M2 16.2C2 15.2 4.4 14.7 8 14.7H20.2V16.4C20.2 17.2 19.5 17.8 18.6 17.8H7C4 17.8 2 17.2 2 16.2Z"
        />
        <path
          d="M13.2 6C11.4 8 11 11.4 11.2 14.7"
          stroke="rgba(0,0,0,.25)"
          strokeWidth="1"
          strokeLinecap="round"
          fill="none"
        />
        <circle cx="13.2" cy="5.7" r="0.9" fill="rgba(0,0,0,.3)" />
      </symbol>

      {/* ۴ — پیراهن */}
      <symbol id="pt-item-4" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M8.6 2.5H10L10.4 6.2C11.6 7 12.4 7 13.6 6.2L14 2.5H15.4L15.6 8C15.6 9.4 15 10.5 14.4 11.4L21 21.5H3L9.6 11.4C9 10.5 8.4 9.4 8.4 8Z"
        />
        <path
          fill="rgba(0,0,0,.22)"
          d="M9.5 11H14.5L14.9 12.4H9.1Z"
        />
        <path
          d="M9.2 21L10.6 12.8M14.8 21L13.4 12.8"
          stroke="rgba(0,0,0,.16)"
          strokeWidth="1"
          strokeLinecap="round"
          fill="none"
        />
      </symbol>

      {/* ۵ — کیف دستی */}
      <symbol id="pt-item-5" viewBox="0 0 24 24">
        <path
          d="M8.2 9V7.4A3.8 3.8 0 0 1 15.8 7.4V9"
          stroke="currentColor"
          strokeWidth="1.8"
          strokeLinecap="round"
          fill="none"
        />
        <path
          fill="currentColor"
          d="M4.4 9H19.6C20.3 9 20.9 9.5 21 10.2L21.9 19.4C22 20.3 21.3 21 20.4 21H3.6C2.7 21 2 20.3 2.1 19.4L3 10.2C3.1 9.5 3.7 9 4.4 9Z"
        />
        <path
          d="M2.6 11.6C6 14.6 9 15.6 12 15.6C15 15.6 18 14.6 21.4 11.6"
          stroke="rgba(0,0,0,.28)"
          strokeWidth="1.2"
          strokeLinecap="round"
          fill="none"
        />
        <circle cx="12" cy="15.8" r="1.2" fill="rgba(255,255,255,.85)" />
      </symbol>

      {/* ۶ — کفش پاشنه‌بلند */}
      <symbol id="pt-item-6" viewBox="0 0 24 24">
        <path
          fill="currentColor"
          d="M3.2 4.6L6.6 4.6C7.2 9.2 9.2 11.4 12.8 13C15.8 14.3 19.6 14 21.6 16.2C22.3 17 21.9 18.2 20.8 18.2H12.6C11.2 18.2 10 17.6 9.2 16.6L7.6 14.6L6.8 20.6H4.6L5.4 12.6C4.2 10.4 3.4 7.6 3.2 4.6Z"
        />
        <path
          d="M8.2 6.4C8.8 9.2 10.4 11 13 12.2"
          stroke="rgba(255,255,255,.5)"
          strokeWidth="1.2"
          strokeLinecap="round"
          fill="none"
        />
        <path
          d="M12.8 18.2H20.8"
          stroke="rgba(0,0,0,.25)"
          strokeWidth="1"
          strokeLinecap="round"
          fill="none"
        />
      </symbol>

      {/* ۷ — ساعت مچی */}
      <symbol id="pt-item-7" viewBox="0 0 24 24">
        <path fill="currentColor" d="M9 2H15L15.6 7.4H8.4Z" />
        <path fill="currentColor" d="M8.4 16.6H15.6L15 22H9Z" />
        <rect
          x="17.1"
          y="11"
          width="1.6"
          height="2"
          rx="0.6"
          fill="currentColor"
        />
        <circle cx="12" cy="12" r="5.6" fill="currentColor" />
        <circle cx="12" cy="12" r="4.1" fill="rgba(255,255,255,.88)" />
        <path
          d="M12 9.4V12L13.9 13.2"
          stroke="currentColor"
          strokeWidth="1.3"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </symbol>
    </defs>
  </svg>
);

/**
 * props:
 *  - once : اگه true بدی فقط بار اول هر نشست مرورگر انیمیشن کامل اجرا می‌شه
 *           و دفعه‌های بعد کارت مستقیم به شکل جمع‌شده نمایش داده می‌شه
 *           (پیش‌فرض false: با هر رفرش انیمیشن کامل اجرا می‌شه)
 *  - href : اگر بدهی، دکمه‌ی «مشاهده» توی کارت باز نمایش داده می‌شود
 */
export default function ProOnlineToast({ once = false, href }) {
  // hidden → open ⇄ compact
  const [phase, setPhase] = useState("hidden");
  const [items, setItems] = useState([]);
  const [origin, setOrigin] = useState({ x: 0, y: 0 });
  const [burstId, setBurstId] = useState(0);
  const [leavesOn, setLeavesOn] = useState(false);

  const iconRef = useRef(null);
  const leavesTimer = useRef(null);

  // ورود اولیه‌ی کارت بعد از لود صفحه
  useEffect(() => {
    let seen = false;
    try {
      seen = once && !!sessionStorage.getItem(SEEN_KEY);
    } catch {
      /* sessionStorage ممکن است در دسترس نباشد */
    }

    const t = setTimeout(() => {
      try {
        sessionStorage.setItem(SEEN_KEY, "1");
      } catch {
        /* ignore */
      }
      // اگه قبلاً دیده شده، مستقیم به شکل جمع‌شده نشون بده
      setPhase(seen ? "compact" : "open");
    }, INTRO_DELAY_MS);

    return () => {
      clearTimeout(t);
      clearTimeout(leavesTimer.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // هر بار که کارت باز می‌شه: بعد از مکث می‌ترکه، بعد جمع می‌شه
  useEffect(() => {
    if (phase !== "open") return;
    const t1 = setTimeout(burst, BURST_DELAY_MS);
    const t2 = setTimeout(() => setPhase("compact"), OPEN_MS);
    return () => {
      clearTimeout(t1);
      clearTimeout(t2);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [phase]);

  function burst() {
    const reduceMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)",
    ).matches;
    const el = iconRef.current;
    if (reduceMotion || !el) return;

    // مبدأ ترکیدن: مرکز آیکن کارت (مختصات نسبت به صفحه‌ی نمایش)
    const r = el.getBoundingClientRect();
    const ox = r.left + r.width / 2;
    const oy = r.top + r.height / 2;

    setOrigin({ x: ox, y: oy });
    setItems(makeItems(ox, oy));
    setBurstId((n) => n + 1);
    setLeavesOn(true);

    clearTimeout(leavesTimer.current);
    leavesTimer.current = setTimeout(() => setLeavesOn(false), LEAVES_MS);
  }

  // کلیک روی کارت: اگه جمع‌شده بود دوباره باز بشه (و بترکه)
  function replay() {
    setPhase((p) => (p === "compact" ? "open" : p));
  }

  return (
    <>
      <div className="pt-root">
        <div
          className={`pt-card pt-card-${phase}`}
          style={{ "--pt-pop-delay": `${BURST_DELAY_MS}ms` }}
          onClick={replay}
          aria-hidden={phase === "hidden"}
        >
          <button
            type="button"
            ref={iconRef}
            className="pt-card-icon"
            aria-label="پرو آنلاین — نمایش دوباره"
          >
            <BagIcon />
          </button>

          <div className="pt-card-body">
            <div className="pt-card-top">
              <strong>پرو آنلاین</strong>
              {/* <em className="pt-card-tag">جدید</em> */}
            </div>

            <div className="pt-card-more">
              <span>
                قابلیت جدید اضافه شد! از همین الان می‌تونی ازش استفاده کنی.
              </span>
              {href && (
                <a
                  href={href}
                  className="pt-card-cta"
                  onClick={(e) => e.stopPropagation()}
                >
                  مشاهده
                </a>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* لایه‌ی آیتم‌ها روی کل صفحه — بیرون از hero رندر می‌شه
          تا perspective و overflow بخش‌های صفحه روش اثر نذارن */}
      {leavesOn &&
        typeof document !== "undefined" &&
        createPortal(
          <div className="pt-leaves" aria-hidden="true">
            <ItemSprites />
            <div
              key={burstId}
              className="pt-burst"
              style={{ left: origin.x, top: origin.y }}
            >
              <span className="pt-ring" />
              {items.map((l) => (
                <span
                  key={l.id}
                  className="pt-leaf"
                  style={{
                    "--dx": `${l.dx}px`,
                    "--dy": `${l.dy}px`,
                    "--drift": `${l.drift}px`,
                    "--rot": `${l.rot}deg`,
                    "--size": `${l.size}px`,
                    "--delay": `${l.delay}s`,
                    "--dur": `${l.dur}s`,
                    "--sway-dur": `${l.swayDur}s`,
                    "--sway": `${l.sway}deg`,
                    "--c": l.color,
                  }}
                >
                  <span className="pt-leaf-in">
                    <svg viewBox="0 0 24 24">
                      <use href={`#pt-item-${l.shape}`} />
                    </svg>
                  </span>
                </span>
              ))}
            </div>
          </div>,
          document.body,
        )}
    </>
  );
}
